<template>
  <AutoComplete
    :items="options"
    @search="onInput"
    @select="onSelect"
  />
</template>

<script>
import AutoComplete from '@/components/AutoComplete'

export default {
  name: 'SearchField',
  components: {
    AutoComplete
  },
  data () {
    return {
      options: []
    }
  },
  emits: [
    'select'
  ],
  methods: {
    async onInput (event) {
      try {
        const { data } = await this.$api.field.fieldsValueText(event)
        const options = data?.list ?? []

        this.options = options.map(item => ({
          value: item.id,
          text: item.title,
          availableWeekdays: item.availableDaysWeek
        }))
      } catch (e) {
        console.log(e)
      }
    },
    onSelect (event) {
      this.$emit('select', this.options.find(i => i.value === event))
    }
  }
}
</script>
